import http from "@/Services/Axios";
import { getSecureItem } from "@/Utils/SecureStorage";
import { extractDisplayFileName } from "@/Services/StoredFileService";

const AUTH_HEADERS = () => ({
  Authorization: `Bearer ${getSecureItem("qr-token")}`,
});

export function extractCertificateId(urlOrId) {
  const urlMatch = urlOrId.match(/certificate\/([^/?#]+)/i);
  if (urlMatch?.[1]) return urlMatch[1];
  return urlOrId;
}

function resolveFileUrl(licenseFile) {
  if (!licenseFile) return null;
  if (/^https?:\/\//i.test(licenseFile)) return licenseFile;

  const base = (process.env.VUE_APP_ASSETS_URL || "").replace(/\/$/, "");
  const path = String(licenseFile).replace(/^\//, "");
  return base ? `${base}/${path}` : `/${path}`;
}

export async function fetchCertificate(id) {
  const response = await http.get(`/Qr/${id}`, {
    headers: AUTH_HEADERS(),
  });

  const data = response.data || {};
  const licenseFile = data.licenseFile || data.file || data.url;
  const fileUrl = resolveFileUrl(licenseFile);

  return {
    ...data,
    licenseFile,
    fileUrl,
    fileName: extractDisplayFileName(licenseFile, "certificate.pdf"),
  };
}
